import { useState } from 'react';
import { Badge, Button, Modal } from '@ftedn/ui';
import { useAuth } from '../../hooks/useAuth';
import './PhoneCollectionPrompt.css';

export function PhoneCollectionPrompt() {
  const { user, skipPhonePrompt } = useAuth();
  const [loading, setLoading] = useState(false);

  const open = Boolean(user?.needsPhoneCollection && !user?.phonePromptDeferredAt);

  if (!user || !open) {
    return null;
  }

  async function handleSkip() {
    setLoading(true);
    try {
      await skipPhonePrompt();
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      actions={(
        <Button loading={loading} onClick={handleSkip} variant="navy">
          Skip for now
        </Button>
      )}
      description="Phone is optional for now, but it unlocks the most time-sensitive FTEDN updates."
      onClose={handleSkip}
      open={open}
      title="Want the fast-lane alerts later?"
    >
      <div className="phone-prompt">
        <Badge className="phone-prompt-badge" tone="sage">Optional</Badge>
        <p className="phone-prompt-copy">
          Add a phone number when you&apos;re ready for shipment alerts, vote-close nudges, and streak reminders.
        </p>
        <ul className="phone-prompt-list">
          <li>Shipment status the moment your beta kit moves.</li>
          <li>Vote windows before they close.</li>
          <li>Gentle streak nudges when you want them.</li>
        </ul>
      </div>
    </Modal>
  );
}
